module.exports = __webpack_public_path__ + "img/sidewalks.46ad68b8.jpg";